
import React, {
    ReactNode,
    useEffect,
    useState,
    useMemo,
} from "react";
import {
    Card,
    Grid,
    CardContent,
    Typography,
    Button,
    Box,
    CardHeader,
    List,
    ListItemButton,
    ListItemText,
    useTheme,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    CircularProgress,
    Alert,
    Divider,
    ListItem,
    TableRow,
    TableCell,
    IconButton,
    Collapse,
    TableContainer,
    Table,
    TableHead,
    TableBody,
    LinearProgress,
    Paper,
    TextField,
    SwipeableDrawer,
    Chip,
    Avatar,
} from "@mui/material";

import ReactApexChart from 'react-apexcharts';
import "./style.css";
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import axios from "axios";
import HOST_URL from "../../utils/Url";
import { secureGetItem } from "../../utils/encryption";
import CountUp from 'react-countup';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import CloseIcon from '@mui/icons-material/Close';
import { getSecureDevId, getSecureSubDeptId } from "../../utils/storageHelpers";
// Import New Icons for Stat Cards
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import CategoryOutlinedIcon from '@mui/icons-material/CategoryOutlined';
import FolderZipOutlinedIcon from '@mui/icons-material/FolderZipOutlined';
import CallSplitOutlinedIcon from '@mui/icons-material/CallSplitOutlined';
import VisibilityIcon from '@mui/icons-material/Visibility';
// --- Interfaces ---
interface DocRowProps {
    doc: any;
    isOpen: boolean;
    onToggle: () => void;
    formatDate: (dateString: string | null | undefined) => string;
    theme: any;
    isEvenRow: boolean;
}

// --- Helper Functions ---
const formatDate = (dateString: string | null | undefined): string => {
    if (!dateString) return '-';
    try {
        const date = new Date(dateString);
        if (isNaN(date.getTime())) {
            console.warn("Could not parse date directly:", dateString);
            return 'Invalid Date';
        }
        const returnDate = date.toLocaleDateString(undefined, {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit'
        });
        return returnDate.replace(/\//g, '-');
    } catch (e) {
        console.error("Error formatting date:", dateString, e);
        return 'Invalid Date Format';
    }
};

// --- DocRow Component (For Document Details Modal AND Drawer) ---
// function DocRow({ doc, isOpen, onToggle, formatDate, theme, isEvenRow }: DocRowProps) {
//     const necessaryFields = {
//         id: doc.docMid,
//         fileNo: doc.fileNo || '-',
//         definition: doc.fileDef || '-',
//         department: doc.department_Name || '-',
//         subject: doc.subj || '-',
//         date: formatDate(doc.fDate),
//         fileCount: doc.member_DocFiles?.length ?? 0,
//     };

//     return (
//         <React.Fragment>
//             <TableRow
//                 sx={{
//                     '& > *': { borderBottom: 'unset' },
//                     backgroundColor: isEvenRow ? theme.palette.action.hover : 'inherit',
//                     '&:hover': { backgroundColor: theme.palette.action.selected },
//                     cursor: 'pointer',
//                 }}
//                 onClick={onToggle}
//             >
//                 <TableCell sx={{ padding: '6px', width: '50px' }}>
//                     <IconButton aria-label="expand row" size="small" onClick={(e) => { e.stopPropagation(); onToggle(); }}>
//                         {isOpen ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
//                     </IconButton>
//                 </TableCell>
//                 <TableCell sx={{ padding: '6px 10px' }}>{necessaryFields.fileNo}</TableCell>
//                 <TableCell sx={{ padding: '6px 10px', maxWidth: '250px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }} title={necessaryFields.definition}>{necessaryFields.definition}</TableCell>
//                 <TableCell sx={{ padding: '6px 10px' }}>{necessaryFields.department}</TableCell>
//                 <TableCell sx={{ padding: '6px 10px' }}>{necessaryFields.date}</TableCell>
//                 <TableCell sx={{ padding: '6px 10px' }}>{necessaryFields.fileCount}</TableCell>
//             </TableRow>
//             <TableRow>
//                 <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={7}>
//                     <Collapse in={isOpen} timeout="auto" unmountOnExit>
//                         <Box sx={{ margin: 1, p: 2, backgroundColor: theme.palette.grey[100], borderRadius: '4px', border: `1px solid ${theme.palette.divider}` }}>
//                             <Typography variant="h6" gutterBottom component="div" sx={{ fontWeight: 'medium', color: theme.palette.primary.dark }}>
//                                 Details for Document #{doc.docMid}
//                             </Typography>
//                             <Divider sx={{ my: 1 }} />
//                             <Typography variant="subtitle1" sx={{ fontWeight: 'bold', mt: 1, mb: 1 }}>Core Information</Typography>
//                             <Grid container spacing={1.5} sx={{ mb: 2, fontSize: '0.9rem' }}>
//                                 <Grid item xs={12} sm={6} md={4}><Typography variant="body2"><strong>Synopsis:</strong> {doc.synopsis || '-'}</Typography></Grid>
//                                 <Grid item xs={12} sm={6} md={4}><Typography variant="body2"><strong>Completion:</strong> {doc.complt || '-'}</Typography></Grid>
//                                 <Grid item xs={12} sm={6} md={4}><Typography variant="body2"><strong>Auth Person:</strong> {doc.authPersn || '-'}</Typography></Grid>
//                                 <Grid item xs={12} sm={6} md={4}><Typography variant="body2"><strong>Sub-Subject Name:</strong> {doc.sub_Subject_Name || '-'}</Typography></Grid>
//                                 <Grid item xs={12} sm={6} md={4}><Typography variant="body2"><strong>File Type Name:</strong> {doc.fileType_Name || doc.fileType || '-'}</Typography></Grid>
//                                 <Grid item xs={12} sm={6} md={4}><Typography variant="body2"><strong>Period From:</strong> {formatDate(doc.perFr)}</Typography></Grid>
//                                 <Grid item xs={12} sm={6} md={4}><Typography variant="body2"><strong>Period Until:</strong> {formatDate(doc.perUt)}</Typography></Grid>
//                                 <Grid item xs={12} sm={6} md={4}><Typography variant="body2"><strong>Create Date:</strong> {formatDate(doc.createdate)}</Typography></Grid>
//                             </Grid>
//                             <Divider sx={{ my: 1 }} />
//                             <Typography variant="subtitle1" sx={{ fontWeight: 'bold', mt: 2, mb: 1 }}>
//                                 Associated Files ({doc.member_DocFiles?.length ?? 0})
//                             </Typography>
//                             {doc.member_DocFiles && doc.member_DocFiles.length > 0 ? (
//                                 <Grid container spacing={2} sx={{ pt: 1 }}>
//                                     {doc.member_DocFiles.map((file: any, fileIndex: number) => (
//                                         <Grid item xs={12} sm={6} md={3} key={file.pdFid || `file-${fileIndex}`}>
//                                             <Paper elevation={1} sx={{ p: 1.5, height: '100%', display: 'flex', flexDirection: 'column' }}>
//                                                 <Typography variant="body1" component="div" sx={{ fontWeight: 'bold', mb: 0.5, wordBreak: 'break-word' }}>
//                                                     {file.pdfName || 'Unnamed File'} {file.pdFid ? `(ID: ${file.pdFid})` : ''}
//                                                 </Typography>
//                                                 <Divider sx={{ mb: 1 }} />
//                                                 <Box sx={{ fontSize: '0.8rem', flexGrow: 1 }}>
//                                                     <Typography variant="caption" display="block"><strong>Keywords:</strong> {file.keywords || '-'}</Typography>
//                                                     <Typography variant="caption" display="block"><strong>Sub Type:</strong> {file.subFtype || '-'}</Typography>
//                                                     <Typography variant="caption" display="block"><strong>File Date:</strong> {formatDate(file.pDate)}</Typography>
//                                                     <Typography variant="caption" display="block"><strong>Is Main:</strong> {file.isMain ? 'Yes' : 'No'}</Typography>
//                                                     <Typography variant="caption" display="block"><strong>Entry Date:</strong> {formatDate(file.entryDate)}</Typography>
//                                                     <Typography variant="caption" display="block" sx={{ wordBreak: 'break-all', mt: 0.5 }}>
//                                                         <strong>Path:</strong> {file.pdfPath || '-'}
//                                                     </Typography>
//                                                 </Box>
//                                             </Paper>
//                                         </Grid>
//                                     ))}
//                                 </Grid>
//                             ) : (
//                                 <Typography variant="body2" color="textSecondary" sx={{ fontStyle: 'italic', mt: 1 }}>No associated files found.</Typography>
//                             )}
//                         </Box>
//                     </Collapse>
//                 </TableCell>
//             </TableRow>
//         </React.Fragment>
//     );
// }
// --- DocRow Component (For Document Details Modal AND Drawer) ---
function DocRow({ doc, isOpen, onToggle, formatDate, theme, isEvenRow }: DocRowProps) {
    const necessaryFields = {
        id: doc.docMid,
        fileNo: doc.fileNo || '-',
        definition: doc.fileDef || '-',
        department: doc.department_Name || '-',
        subject: doc.subj || '-',
        date: formatDate(doc.fDate),
        fileCount: doc.member_DocFiles?.length ?? 0,
        pdfPath: doc.member_DocFiles?.[0]?.pdfPath || null // Get first file's PDF path
    };

    // Function to open document preview
    const handlePreview = (e: React.MouseEvent, pdfPath: string, fileName: string) => {
        e.stopPropagation(); // Prevent row click
        if (pdfPath) {
            window.open(pdfPath, '_blank');
        } else {
            alert('Document path not available');
        }
    };

    return (
        <React.Fragment>
            <TableRow
                sx={{
                    '& > *': { borderBottom: 'unset' },
                    backgroundColor: isEvenRow ? theme.palette.action.hover : 'inherit',
                    '&:hover': { backgroundColor: theme.palette.action.selected },
                    cursor: 'pointer',
                }}
                onClick={onToggle}
            >
                <TableCell sx={{ padding: '6px', width: '50px' }}>
                    <IconButton aria-label="expand row" size="small" onClick={(e) => { e.stopPropagation(); onToggle(); }}>
                        {isOpen ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                    </IconButton>
                </TableCell>
                <TableCell sx={{ padding: '6px 10px' }}>{necessaryFields.fileNo}</TableCell>
                <TableCell sx={{ padding: '6px 10px', maxWidth: '250px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }} title={necessaryFields.definition}>{necessaryFields.definition}</TableCell>
                <TableCell sx={{ padding: '6px 10px' }}>{necessaryFields.department}</TableCell>
                <TableCell sx={{ padding: '6px 10px' }}>{necessaryFields.date}</TableCell>
                <TableCell sx={{ padding: '6px 10px' }}>{necessaryFields.fileCount}</TableCell>
                <TableCell sx={{ padding: '6px 10px' }} align="center">
                    {necessaryFields.pdfPath ? (
                        <IconButton
                            aria-label="preview document"
                            size="small"
                            onClick={(e) => handlePreview(e, necessaryFields.pdfPath, necessaryFields.fileNo)}
                            sx={{
                                color: theme.palette.primary.main,
                                '&:hover': {
                                    backgroundColor: theme.palette.primary.light + '20',
                                }
                            }}
                        >
                            <VisibilityIcon />
                        </IconButton>
                    ) : (
                        <Typography variant="caption" color="textSecondary">-</Typography>
                    )}
                </TableCell>
            </TableRow>
            <TableRow>
                <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={8}>
                    <Collapse in={isOpen} timeout="auto" unmountOnExit>
                        <Box sx={{ margin: 1, p: 2, backgroundColor: theme.palette.grey[100], borderRadius: '4px', border: `1px solid ${theme.palette.divider}` }}>
                            <Typography variant="h6" gutterBottom component="div" sx={{ fontWeight: 'medium', color: theme.palette.primary.dark }}>
                                Details for Document #{doc.docMid}
                            </Typography>
                            <Divider sx={{ my: 1 }} />
                            <Typography variant="subtitle1" sx={{ fontWeight: 'bold', mt: 1, mb: 1 }}>Core Information</Typography>
                            <Grid container spacing={1.5} sx={{ mb: 2, fontSize: '0.9rem' }}>
                                <Grid item xs={12} sm={6} md={4}><Typography variant="body2"><strong>Synopsis:</strong> {doc.synopsis || '-'}</Typography></Grid>
                                <Grid item xs={12} sm={6} md={4}><Typography variant="body2"><strong>Completion:</strong> {doc.complt || '-'}</Typography></Grid>
                                <Grid item xs={12} sm={6} md={4}><Typography variant="body2"><strong>Auth Person:</strong> {doc.authPersn || '-'}</Typography></Grid>
                                <Grid item xs={12} sm={6} md={4}><Typography variant="body2"><strong>Sub-Subject Name:</strong> {doc.sub_Subject_Name || '-'}</Typography></Grid>
                                <Grid item xs={12} sm={6} md={4}><Typography variant="body2"><strong>File Type Name:</strong> {doc.fileType_Name || doc.fileType || '-'}</Typography></Grid>
                                <Grid item xs={12} sm={6} md={4}><Typography variant="body2"><strong>Period From:</strong> {formatDate(doc.perFr)}</Typography></Grid>
                                <Grid item xs={12} sm={6} md={4}><Typography variant="body2"><strong>Period Until:</strong> {formatDate(doc.perUt)}</Typography></Grid>
                                <Grid item xs={12} sm={6} md={4}><Typography variant="body2"><strong>Create Date:</strong> {formatDate(doc.createdate)}</Typography></Grid>
                            </Grid>
                            <Divider sx={{ my: 1 }} />
                            <Typography variant="subtitle1" sx={{ fontWeight: 'bold', mt: 2, mb: 1 }}>
                                Associated Files ({doc.member_DocFiles?.length ?? 0})
                            </Typography>
                            {doc.member_DocFiles && doc.member_DocFiles.length > 0 ? (
                                <Grid container spacing={2} sx={{ pt: 1 }}>
                                    {doc.member_DocFiles.map((file: any, fileIndex: number) => (
                                        <Grid item xs={12} sm={6} md={3} key={file.pdFid || `file-${fileIndex}`}>
                                            <Paper elevation={1} sx={{ p: 1.5, height: '100%', display: 'flex', flexDirection: 'column' }}>
                                                <Typography variant="body1" component="div" sx={{ fontWeight: 'bold', mb: 0.5, wordBreak: 'break-word' }}>
                                                    {file.pdfName || 'Unnamed File'} {file.pdFid ? `(ID: ${file.pdFid})` : ''}
                                                </Typography>
                                                <Divider sx={{ mb: 1 }} />
                                                <Box sx={{ fontSize: '0.8rem', flexGrow: 1 }}>
                                                    <Typography variant="caption" display="block"><strong>Keywords:</strong> {file.keywords || '-'}</Typography>
                                                    <Typography variant="caption" display="block"><strong>Sub Type:</strong> {file.subFtype || '-'}</Typography>
                                                    <Typography variant="caption" display="block"><strong>File Date:</strong> {formatDate(file.pDate)}</Typography>
                                                    <Typography variant="caption" display="block"><strong>Is Main:</strong> {file.isMain ? 'Yes' : 'No'}</Typography>
                                                    <Typography variant="caption" display="block"><strong>Entry Date:</strong> {formatDate(file.entryDate)}</Typography>
                                                    <Typography variant="caption" display="block" sx={{ wordBreak: 'break-all', mt: 0.5 }}>
                                                        <strong>Path:</strong> {file.pdfPath || '-'}
                                                    </Typography>
                                                </Box>
                                            </Paper>
                                        </Grid>
                                    ))}
                                </Grid>
                            ) : (
                                <Typography variant="body2" color="textSecondary" sx={{ fontStyle: 'italic', mt: 1 }}>No associated files found.</Typography>
                            )}
                        </Box>
                    </Collapse>
                </TableCell>
            </TableRow>
        </React.Fragment>
    );
}

// Main HomePage Component
export default function HomePage(): ReactNode {
    const theme = useTheme();
    const iOS = typeof navigator !== 'undefined' && /iPad|iPhone|iPod/.test(navigator.userAgent);
    const [filteredDepartmentList, setFilteredDepartmentList] = useState<any[]>([]);

    // --- State ---
    const [TotalCount, setTotalCount] = useState<number>(0);
    const [FileTypeCount, setFileTypeCount] = useState(0);
    const [IndexCount, setIndexCount] = useState<number>(0);
    const [FileCount, setFileCount] = useState<number>(0);
    const [SplitCount, setSplitCount] = useState<number>(0);
    const [DepartmentList, setDepartmentList] = useState<any[]>([]);
    const [selectedDepartment, setSelectedDepartment] = useState<string | null>(null);
    const [selectedDepartmentId, setSelectedDepartmentId] = useState<number | null>(null);
    const [deptCountRawData, setDeptCountRawData] = useState<any[]>([]);
    const [isDeptChartLoading, setIsDeptChartLoading] = useState<boolean>(false);
    const [deptChartError, setDeptChartError] = useState<string | null>(null);

    // Modal states
    const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
    const [modalData, setModalData] = useState<any[]>([]);
    const [isLoadingModal, setIsLoadingModal] = useState<boolean>(false);
    const [modalError, setModalError] = useState<string | null>(null);
    const [openRowId, setOpenRowId] = useState<number | null>(null);
    const [searchQuery, setSearchQuery] = useState<string>("");

    // Pagination for Document Details Modal
    const [modalPage, setModalPage] = useState(1);
    const [modalRowsPerPage] = useState(5); // showing only 5 rows
    // Pagination for Department Drawer
    const [drawerPage, setDrawerPage] = useState(1);
    const [drawerRowsPerPage] = useState(9); // same as modal



    const [isDocTypeModalOpen, setIsDocTypeModalOpen] = useState<boolean>(false);
    const [docTypeData, setDocTypeData] = useState<any[]>([]);
    const [isLoadingDocTypeModal, setIsLoadingDocTypeModal] = useState<boolean>(false);
    const [docTypeModalError, setDocTypeModalError] = useState<string | null>(null);
    const [docTypeSearchQuery, setDocTypeSearchQuery] = useState<string>("");

    const [isIndex, setIndex] = useState<any[]>([]);
    const [isTotalFilesModalOpen, setIsTotalFilesModalOpen] = useState<boolean>(false);
    const [isLoadingTotalFiles, setIsLoadingTotalFiles] = useState<boolean>(false);
    const [totalFilesSearchQuery, setTotalFilesSearchQuery] = useState<string>("");

    // Drawer state
    const [isDeptDrawerOpen, setIsDeptDrawerOpen] = useState<boolean>(false);
    const [selectedDeptData, setSelectedDeptData] = useState<any[]>([]);
    const [isLoadingDeptData, setIsLoadingDeptData] = useState<boolean>(false);
    const [deptDataError, setDeptDataError] = useState<string | null>(null);
    const [deptDataSearchQuery, setDeptDataSearchQuery] = useState<string>("");
    const [openDrawerRowId, setOpenDrawerRowId] = useState<number | null>(null);

    // Chart states
    const [chartOptions, setChartOptions] = useState<any>(null);
    const [chartSeries, setChartSeries] = useState<any[]>([]);

    // --- Effects ---
    useEffect(() => {
        getTotalDoc();
        getDepartmentList();
        // getDepartmentCountChartData();
         getDepartmentCountChartDataOnlyForChart();
        getTotalCount();
         getTotalTypeCount();
    }, []);

    useEffect(() => {
        if (deptCountRawData && deptCountRawData.length > 0) {
            const categories = deptCountRawData.map(item =>
                item.divisionName || item.department || 'Unknown Dept'
            );
            const seriesData = deptCountRawData.map(item =>
                Math.round(item.totalCount || item.count || 0) // Ensure whole numbers
            );

            setChartOptions({
                chart: {
                    type: 'bar',
                    height: '100%',
                    toolbar: {
                        show: true,
                        tools: {
                            download: true,
                            selection: true,
                            zoom: true,
                            zoomin: true,
                            zoomout: true,
                            pan: true,
                            reset: true
                        }
                    },
                    animations: {
                        enabled: true,
                        easing: 'easeinout',
                        speed: 800
                    },
                    zoom: {
                        enabled: true,
                        type: 'x',
                        autoScaleYaxis: true
                    }
                },
                plotOptions: {
                    bar: {
                        borderRadius: 6,
                        horizontal: false,
                        columnWidth: '55%',
                        dataLabels: {
                            position: 'top'
                        }
                    }
                },
                dataLabels: {
                    enabled: true,
                    offsetY: -20,
                    style: {
                        fontSize: '12px',
                        colors: [theme.palette.text.primary]
                    },
                    formatter: function (val: number) {
                        return Math.round(val).toString(); // Ensure whole numbers in labels
                    }
                },
                xaxis: {
                    categories: categories,
                    labels: {
                        style: {
                            fontSize: '12px',
                            fontWeight: 600,
                            colors: theme.palette.text.primary
                        },
                        rotate: -45,
                        rotateAlways: true,
                        trim: true,
                        maxHeight: 120
                    },
                    axisBorder: {
                        show: true,
                        color: theme.palette.divider,
                        height: 2
                    },
                    axisTicks: {
                        show: true,
                        color: theme.palette.divider
                    },
                    tooltip: {
                        enabled: false
                    }
                },
                yaxis: {

                    labels: {
                        style: {
                            fontSize: '12px',
                            colors: theme.palette.text.secondary
                        },
                        formatter: function (val: number) {
                            return Math.round(val).toString(); // Ensure whole numbers on Y-axis
                        }
                    },
                    forceNiceScale: true,
                    tickAmount: 5
                },
                grid: {
                    borderColor: theme.palette.divider,
                    strokeDashArray: 4,
                    padding: {
                        top: 0,
                        right: 0,
                        bottom: 0,
                        left: 10
                    },
                    xaxis: {
                        lines: {
                            show: true
                        }
                    },
                    yaxis: {
                        lines: {
                            show: true
                        }
                    }
                },
                tooltip: {
                    theme: theme.palette.mode,
                    style: {
                        fontSize: '14px'
                    },
                    y: {
                        formatter: function (val: number) {
                            return Math.round(val) + ' documents'; // Ensure whole numbers in tooltip
                        },
                        title: {
                            formatter: function () {
                                return 'Count:';
                            }
                        }
                    }
                },
                colors: [theme.palette.secondary.main],
                fill: {
                    opacity: 0.9,
                    type: 'solid'
                },
                stroke: {
                    show: true,
                    width: 2,
                    colors: ['transparent']
                },
                legend: {
                    show: false
                }
            });

            setChartSeries([{
                name: 'Document Count',
                data: seriesData
            }]);
        } else {
            setChartOptions(null);
            setChartSeries([]);
        }
    }, [deptCountRawData, theme]);

    // --- API Calls ---
    const getTotalDoc = () => {
        const collectData = { type: 1, pageID: 1, searchBy: "", fromdt: "1900-01-01", todt: new Date().toISOString().slice(0, 10), print: 1 };
        axios.post(HOST_URL.HOST_URL2 + `DashboardEntity/GetDashboardData`, collectData)
            .then((res) => {
                const stats = res?.data?.data?.dashboardcls?.[0];
                if (stats) {
                    // setTotalCount(Math.round(stats.totDoc || 0)); // Ensure whole number
                    setFileCount(Math.round(stats.totType || 0)); // Ensure whole number
                    setIndexCount(Math.round(stats.totalDepartment || 0)); // Ensure whole number
                    setSplitCount(Math.round(stats.totalSubject || 0)); // Ensure whole number
                } else {
                    console.warn("Dashboard stats data not found in API response:", res?.data);
                }
            })
            .catch(error => console.error("Error fetching total counts:", error));
    };

    const getTotalFilesDataAndShowModal = () => {
        setIsLoadingTotalFiles(true);
        setIndex([]);
        setTotalFilesSearchQuery("");
        setIsTotalFilesModalOpen(true);
        const collectData = { type: 10, pageID: 1, searchBy: "", fromdt: "1900-01-01", todt: new Date().toISOString().slice(0, 10), print: 1 };
        axios.post(HOST_URL.HOST_URL2 + `DashboardEntity/GetDashboardData`, collectData)
            .then((res) => {
                const data = res?.data?.data?.totalIndex;
                setIndex(Array.isArray(data) ? data : []);
            })
            .catch(error => {
                console.error("Error fetching total index/split files:", error);
                setIndex([]);
            })
            .finally(() => setIsLoadingTotalFiles(false));
    };

    const getDepartmentList = () => {
        try {
            const devIdData = secureGetItem("devID");
            const devId = devIdData !== null && devIdData !== "null" ? devIdData : -1;

            const collectData = {
                id: typeof devId === 'number' ? devId : -1,
                nodeID: -1,
                titleID: -1
            };

            axios.post(HOST_URL.HOST_URL2 + `NewNodeMaster/GetNewNodeMaster`, collectData)
                .then((res) => {
                    const departments: any[] = res?.data?.data || [];
                    setDepartmentList(departments);
                    setFilteredDepartmentList(departments);
                })
                .catch(error => console.error("Error fetching department list:", error));
        } catch (error) {
            console.error("Error getting devID from secure storage:", error);

            // Fallback
            try {
                const devId = localStorage.getItem("devID");
                const collectData = {
                    id: devId === null || devId === "null" ? -1 : Number(devId),
                    nodeID: -1,
                    titleID: -1
                };

                axios.post(HOST_URL.HOST_URL2 + `NewNodeMaster/GetNewNodeMaster`, collectData)
                    .then((res) => {
                        const departments: any[] = res?.data?.data || [];
                        setDepartmentList(departments);
                        setFilteredDepartmentList(departments);
                    })
                    .catch(fallbackError => console.error("Error in fallback department fetch:", fallbackError));
            } catch (fallbackError) {
                console.error("Fallback also failed:", fallbackError);
                setDepartmentList([]);
                setFilteredDepartmentList([]);
            }
        }
    };

const getTotalTypeCount = () => {
    let userRoleLocal = "";

    try {
        const userData = JSON.parse(
            localStorage.getItem("userdetail") || "[]"
        );

        if (userData?.length > 0) {
            const user = userData[0];
            userRoleLocal = user.roleName || user.role || "";
        }
    } catch (error) {
        console.error("Error getting user role:", error);
    }

    const isAdmin =
        userRoleLocal?.toLowerCase() === "admin" ||
        userRoleLocal?.toLowerCase() === "administrator";

    // ✅ FIX: yahan se devId lo
    const devId = getSecureDevId();
    const filterDeptId = isAdmin ? -1 : devId;

    const collectData = {
        docID: -1,
        parentDocId: filterDeptId,
        userId: ""
    };

    axios
        .post(
            HOST_URL.HOST_URL2 + `OtherDocType/GetOtherDocType`,
            collectData
        )
        .then((res) => {
            if (
                res?.data?.isSuccess &&
                Array.isArray(res.data.data)
            ) {
                setFileTypeCount(res.data.data.length);
            } else {
                setFileTypeCount(0);
            }
        })
        .catch((error) => {
            console.error("Error fetching total document type count:", error);
            setFileTypeCount(0);
        });
};


    // const getDepartmentCountChartData = () => {
    //     setIsDeptChartLoading(true);
    //     setDeptChartError(null);
    //     const collectData = { type: 9, pageID: 1, searchBy: "", fromdt: "1900-01-01", todt: new Date().toISOString().slice(0, 10), print: 1 };
    //     axios.post(HOST_URL.HOST_URL2 + `DashboardEntity/GetDashboardData`, collectData)
    //         .then((res) => {
    //             const data = res?.data?.data?.departmentwiseCountRest;
    //             if (data && Array.isArray(data)) {
    //                 // Ensure all counts are whole numbers
    //                 const processedData = data.map(item => ({
    //                     ...item,
    //                     totalCount: Math.round(item.totalCount || 0),
    //                     fileTypeCount: Math.round(item.fileTypeCount || 0),
    //                     count: Math.round(item.count || 0)
    //                 }));
    //                 setDeptCountRawData(processedData);
    //             } else {
    //                 console.warn("API did not return expected department count data format:", res?.data);
    //                 setDeptCountRawData([]);
    //                 setDeptChartError("Invalid data format received for department chart.");
    //             }
    //         })
    //         .catch(error => {
    //             console.error("Error fetching department count chart:", error);
    //             setDeptChartError("Failed to load department chart data.");
    //             setDeptCountRawData([]);
    //         })
    //         .finally(() => setIsDeptChartLoading(false));
    // };

const getDepartmentCountChartData = () => {
    setIsDeptChartLoading(true);
    setDeptChartError(null);

    const collectData = {
        type: 9,
        pageID: 1,
        searchBy: "",
        fromdt: "1900-01-01",
        todt: new Date().toISOString().slice(0, 10),
        print: 1
    };

    axios.post(HOST_URL.HOST_URL2 + `DashboardEntity/GetDashboardData`, collectData)
        .then((res) => {
            const data = res?.data?.data?.departmentwiseCountRest;

            if (data && Array.isArray(data)) {
                const processedData = data.map(item => ({
                    ...item,
                    totalCount: Math.round(item.totalCount || 0),
                    fileTypeCount: Math.round(item.fileTypeCount || 0),
                    count: Math.round(item.count || 0)
                }));

                setDeptCountRawData(processedData);

                // ✅ Check if user is admin
                let userRoleLocal = "";
                try {
                    const userData = JSON.parse(localStorage.getItem("userdetail") || "[]");
                    if (userData?.length > 0) {
                        userRoleLocal = userData[0].roleName || userData[0].role || "";
                    }
                } catch (error) {
                    console.error("Error getting user role:", error);
                }

                const isAdmin = userRoleLocal?.toLowerCase() === "admin" || 
                               userRoleLocal?.toLowerCase() === "administrator";

                let totalFileTypeCount = 0;

                if (isAdmin) {
                    // ✅ Admin: saare departments ka sum
                    totalFileTypeCount = processedData.reduce((sum, item) => sum + (item.fileTypeCount || 0), 0);
                } else {
                    // ✅ Normal user: sirf apne department ka
                    const devId = getSecureDevId();
                    const currentDept = processedData.find(
                        item => Number(item.divisionId) === Number(devId)
                    );
                    totalFileTypeCount = currentDept?.fileTypeCount || 0;
                }

                setFileTypeCount(totalFileTypeCount);

            } else {
                console.warn("API did not return expected department count data format:", res?.data);
                setDeptCountRawData([]);
                setFileTypeCount(0);
                setDeptChartError("Invalid data format received for department chart.");
            }
        })
        .catch(error => {
            console.error("Error fetching department count chart:", error);
            setDeptChartError("Failed to load department chart data.");
            setDeptCountRawData([]);
            setFileTypeCount(0);
        })
        .finally(() => {
            setIsDeptChartLoading(false);
        });
};

// Chart ke liye alag function - ye FileTypeCount set nahi karega
const getDepartmentCountChartDataOnlyForChart = () => {
    setIsDeptChartLoading(true);
    setDeptChartError(null);

    const collectData = {
        type: 9,
        pageID: 1,
        searchBy: "",
        fromdt: "1900-01-01",
        todt: new Date().toISOString().slice(0, 10),
        print: 1
    };

    axios.post(HOST_URL.HOST_URL2 + `DashboardEntity/GetDashboardData`, collectData)
        .then((res) => {
            const data = res?.data?.data?.departmentwiseCountRest;
            if (data && Array.isArray(data)) {
                const processedData = data.map(item => ({
                    ...item,
                    totalCount: Math.round(item.totalCount || 0),
                    fileTypeCount: Math.round(item.fileTypeCount || 0),
                    count: Math.round(item.count || 0)
                }));
                setDeptCountRawData(processedData);
            } else {
                setDeptCountRawData([]);
                setDeptChartError("Invalid data format received for department chart.");
            }
        })
        .catch(error => {
            console.error("Error fetching department count chart:", error);
            setDeptChartError("Failed to load department chart data.");
            setDeptCountRawData([]);
        })
        .finally(() => {
            setIsDeptChartLoading(false);
        });
};

    const devId = getSecureDevId();
    const subDeptId = getSecureSubDeptId();
    const getDocEntryAndShowModal = () => {
        setIsLoadingModal(true);
        setModalError(null);
        setModalData([]);
        setOpenRowId(null);
        setSearchQuery("");
        setIsModalOpen(true);
        const collectData = {
            docMid: -1, fileTypId: -1,
            //@ts-ignore 
            divisionid: devId === "null" ? -1 : devId,
            subsubjId: -1, user_Id: -1, fileNo: "",
            subDeptID: subDeptId == null ? -1 : subDeptId,
            synopsis: "",
            complt: ""
        };
        axios.post(HOST_URL.HOST_URL2 + `DocMangr/GetDocMangr`, collectData)
            .then((res) => {
                if (res?.data?.isSuccess && Array.isArray(res.data.data)) {
                    setModalData(res.data.data);
                } else {
                    setModalError(res?.data?.mesg || "Failed to fetch data or invalid format received.");
                    setModalData([]);
                }
            })
            .catch((error) => {
                console.error("Error fetching document entry data:", error);
                setModalError("An error occurred while fetching document details.");
                setModalData([]);
            })
            .finally(() => setIsLoadingModal(false));
    };

    const getTotalCount = () => {
        const collectData = {
            docMid: -1, fileTypId: -1,
            //@ts-ignore 
            divisionid: devId === "null" ? -1 : devId,
            subsubjId: -1, user_Id: -1, fileNo: "",
            subDeptID: subDeptId == null ? -1 : subDeptId,
            synopsis: "",
            complt: ""
        };
        axios.post(HOST_URL.HOST_URL2 + `DocMangr/GetDocMangr`, collectData)
            .then((res) => {
                setTotalCount(Math.round(res.data.data.length || 0));
            })
            .catch((error) => {
                console.error("Error fetching total count data:", error);
            });
    }

    const getDocTypeAndShowModal = () => {
    setIsLoadingDocTypeModal(true);
    setDocTypeModalError(null);
    setDocTypeData([]);
    setDocTypeSearchQuery("");
    setIsDocTypeModalOpen(true);

    // Get department from secure storage
    const devId = getSecureDevId();

    console.log("========== GET DOC TYPE ==========");
    console.log("Secure Dev ID:", devId);

    let userRoleLocal = "";

    try {
        const userData = JSON.parse(
            localStorage.getItem("userdetail") || "[]"
        );

        console.log("User Data:", userData);

        if (userData?.length > 0) {
            const user = userData[0];

            userRoleLocal = user.roleName || user.role || "";

            console.log("User Role:", userRoleLocal);
        }
    } catch (error) {
        console.error("Error getting user data:", error);
    }

    const isAdmin =
        userRoleLocal?.toLowerCase() === "admin" ||
        userRoleLocal?.toLowerCase() === "administrator";

    // Admin => -1
    // Normal user => secure department ID
    const filterDeptId = isAdmin ? -1 : devId;

    console.log("Is Admin:", isAdmin);
    console.log("Final parentDocId:", filterDeptId);

    const collectData = {
        docID: -1,
        parentDocId: filterDeptId,
        userId: ""
    };

    console.log("FINAL API PAYLOAD:", collectData);

    axios
        .post(
            HOST_URL.HOST_URL2 + `OtherDocType/GetOtherDocType`,
            collectData
        )
        .then((res) => {
            console.log("Doc Type API Response:", res);

            if (
                res?.data?.isSuccess &&
                Array.isArray(res.data.data)
            ) {
                setDocTypeData(res.data.data);
            } else {
                setDocTypeModalError(
                    res?.data?.mesg ||
                    "Failed to fetch document types or invalid format received."
                );
                setDocTypeData([]);
            }
        })
        .catch((error) => {
            console.error(
                "Error fetching document type data:",
                error
            );

            setDocTypeModalError(
                "An error occurred while fetching document types."
            );

            setDocTypeData([]);
        })
        .finally(() => {
            setIsLoadingDocTypeModal(false);
        });
};


    // --- Event Handlers ---
    const handleDepartmentClick = async (dept: any) => {
        const deptId = dept?.id;
        const deptName = dept?.name;
        if (!deptId || !deptName) return;

        setSelectedDepartment(deptName);
        setSelectedDepartmentId(deptId);
        setIsLoadingDeptData(true);
        setDeptDataError(null);
        setSelectedDeptData([]);
        setDeptDataSearchQuery("");
        setOpenDrawerRowId(null);
        setIsDeptDrawerOpen(true);

        const collectData = {
            docMid: -1, fileTypId: -1, divisionid: devId == null ? -1 : devId,
            subsubjId: -1, user_Id: -1, fileNo: "",
            subDeptID: subDeptId == null ? -1 : subDeptId,
            synopsis: "",
            complt: ""
        };

        try {
            const resp = await axios.post(HOST_URL.HOST_URL2 + `DocMangr/GetDocMangr`, collectData);
            if (resp?.data?.isSuccess && Array.isArray(resp.data.data)) {
                setSelectedDeptData(resp.data.data);
            } else {
                console.warn("Department data fetch warning:", resp?.data?.mesg);
                setDeptDataError(resp?.data?.mesg || `No documents found for ${deptName}.`);
                setSelectedDeptData([]);
            }
        } catch (error) {
            console.error(`Error fetching data for department ${deptName} (ID: ${deptId}):`, error);
            setDeptDataError(`An error occurred while fetching documents for ${deptName}.`);
            setSelectedDeptData([]);
        } finally {
            setIsLoadingDeptData(false);
        }
    };

    const toggleDrawer = (open: boolean) => (event: React.KeyboardEvent | React.MouseEvent) => {
        if (event && event.type === 'keydown' &&
            ((event as React.KeyboardEvent).key === 'Tab' || (event as React.KeyboardEvent).key === 'Shift')) {
            return;
        }
        setIsDeptDrawerOpen(open);
        if (!open) {
            setSelectedDepartment(null);
            setSelectedDepartmentId(null);
            setDeptDataSearchQuery("");
            setOpenDrawerRowId(null);
        }
    };

    const handleCloseModal = () => { setIsModalOpen(false); setSearchQuery(""); setOpenRowId(null); };
    const handleCloseDocTypeModal = () => { setIsDocTypeModalOpen(false); setDocTypeSearchQuery(""); };
    const handleCloseTotalFilesModal = () => { setIsTotalFilesModalOpen(false); setTotalFilesSearchQuery(""); };

    // --- Filtered Data ---
    const filteredModalData = useMemo(() => {
        if (!searchQuery) return modalData;
        const lowerCaseQuery = searchQuery.toLowerCase();
        return modalData.filter(doc =>
            (doc.fileNo?.toLowerCase().includes(lowerCaseQuery)) ||
            (doc.fileDef?.toLowerCase().includes(lowerCaseQuery)) ||
            (doc.department_Name?.toLowerCase().includes(lowerCaseQuery)) ||
            (doc.subj?.toLowerCase().includes(lowerCaseQuery)) ||
            (String(doc.docMid)?.toLowerCase().includes(lowerCaseQuery))
        );
    }, [modalData, searchQuery]);

    const filteredDocTypeData = useMemo(() => {
        if (!docTypeSearchQuery) return docTypeData;
        const lowerCaseQuery = docTypeSearchQuery.toLowerCase();
        return docTypeData.filter(docType =>
            (docType.doc_Name?.toLowerCase().includes(lowerCaseQuery)) ||
            (docType.doc_shortname?.toLowerCase().includes(lowerCaseQuery)) ||
            (docType.parentDoc_Name?.toLowerCase().includes(lowerCaseQuery)) ||
            (docType.session_year?.toLowerCase().includes(lowerCaseQuery))
        );
    }, [docTypeData, docTypeSearchQuery]);

    const filteredTotalFilesData = useMemo(() => {
        if (!totalFilesSearchQuery || !Array.isArray(isIndex)) return isIndex || [];
        const lowerCaseQuery = totalFilesSearchQuery.toLowerCase();
        return (isIndex || []).filter(item =>
            item?.fileName?.toLowerCase().includes(lowerCaseQuery)
        );
    }, [isIndex, totalFilesSearchQuery]);

    const filteredSelectedDeptData = useMemo(() => {
        if (!deptDataSearchQuery) return selectedDeptData;
        const lowerCaseQuery = deptDataSearchQuery.toLowerCase();
        return selectedDeptData.filter(doc =>
            (doc.fileNo?.toLowerCase().includes(lowerCaseQuery)) ||
            (doc.fileDef?.toLowerCase().includes(lowerCaseQuery)) ||
            (doc.subj?.toLowerCase().includes(lowerCaseQuery)) ||
            (String(doc.docMid)?.toLowerCase().includes(lowerCaseQuery))
        );
    }, [selectedDeptData, deptDataSearchQuery]);

    // --- Styles ---
    const cardHoverStyle = {
        transition: theme.transitions.create(['transform', 'box-shadow', 'background-color'], {
            duration: theme.transitions.duration.short,
        }),
        '&:hover': {
            transform: 'scale(1.03)',
            boxShadow: theme.shadows[10],
        },
    };

    // --- Stat Items Array ---
    const statItems = [
        {
            title: "Total Document",
            count: TotalCount,
            icon: DescriptionOutlinedIcon,
            color: theme.palette.primary.main,
            contrastColor: theme.palette.primary.contrastText,
            onClick: getDocEntryAndShowModal
        },
        {
            title: "Total Type",
            count: FileTypeCount,
            icon: CategoryOutlinedIcon,
            color: theme.palette.secondary.main,
            contrastColor: theme.palette.secondary.contrastText,
            onClick: getDocTypeAndShowModal
        },
        {
            title: "Total Department",
            count: IndexCount,
            icon: FolderZipOutlinedIcon,
            color: theme.palette.success.dark,
            contrastColor: theme.palette.success.contrastText,
            // onClick: getTotalFilesDataAndShowModal
        },
        {
            title: "Total Subject",
            count: SplitCount,
            icon: CallSplitOutlinedIcon,
            color: theme.palette.info.main,
            contrastColor: theme.palette.info.contrastText,
            // onClick: getTotalFilesDataAndShowModal
        },
    ];

    // --- Render ---
    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: 'calc(100vh - 64px)' }}>

            {/* Main Content Area */}
            <Box
                component="main"
                sx={{
                    flexGrow: 1,
                    p: { xs: 1.5, sm: 2, md: 3 },
                    backgroundColor: theme.palette.background.default
                }}
            >
                <Grid container spacing={{ xs: 2, md: 3 }} >

                    {/* Stat Cards Section */}
                    {statItems.map((item: any, index) => (
                        <Grid item xs={12} sm={6} md={3} key={index}>
                            <Card
                                elevation={5}
                                sx={{
                                    borderRadius: '16px',
                                    minHeight: '100px',
                                    display: 'flex',
                                    overflow: 'hidden',
                                    cursor: item.onClick ? 'pointer' : 'default',
                                    backgroundColor: theme.palette.background.paper,
                                    ...cardHoverStyle,
                                }}
                                onClick={item.onClick}
                            >
                                <CardContent sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'space-between',
                                    p: 2.5,
                                    width: '100%',
                                    gap: 2,
                                }}>
                                    <Avatar
                                        sx={{
                                            bgcolor: item.color,
                                            color: item.contrastColor,
                                            width: 60,
                                            height: 60,
                                            boxShadow: `0 4px 12px -2px ${item.color}aa`
                                        }}
                                    >
                                        <item.icon sx={{ fontSize: '2.2rem' }} />
                                    </Avatar>
                                    <Box sx={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        alignItems: 'flex-end',
                                        textAlign: 'right',
                                        overflow: 'hidden',
                                    }}>
                                        <Typography
                                            variant="body2"
                                            color="text.secondary"
                                            sx={{ fontWeight: 500, mb: 0.5 }}
                                            noWrap
                                        >
                                            {item.title}
                                        </Typography>
                                        <Typography
                                            variant="h4"
                                            fontWeight="bold"
                                            color="text.primary"
                                            sx={{ lineHeight: 1.2 }}
                                        >
                                            <CountUp
                                                end={item.count}
                                                duration={1.5}
                                                separator=","
                                                decimals={0} // Ensure no decimals
                                            />
                                        </Typography>
                                    </Box>
                                </CardContent>
                            </Card>
                        </Grid>
                    ))}

                    {/* Department List Card */}
                    <Grid item xs={12} md={4}>
                        <Card elevation={3} sx={{ borderRadius: '12px', height: '400px', display: 'flex', flexDirection: 'column' }}>
                            <CardHeader
                                title="Select Department"
                                titleTypographyProps={{ variant: 'h6', fontWeight: 'bold' }}
                                sx={{
                                    background: `linear-gradient(135deg, ${theme.palette.warning.light} 0%, ${theme.palette.warning.main} 100%)`,
                                    color: theme.palette.warning.contrastText,
                                    py: 1.5,
                                    flexShrink: 0
                                }}
                            />

                            {/* Search Field */}
                            <Box sx={{ p: 1.5, pb: 0, flexShrink: 0 }}>
                                <TextField
                                    fullWidth
                                    size="small"
                                    variant="outlined"
                                    placeholder="Search departments..."
                                    onChange={(e) => {
                                        const searchTerm = e.target.value.toLowerCase();
                                        if (searchTerm === '') {
                                            setFilteredDepartmentList(DepartmentList);
                                        } else {
                                            const filtered = DepartmentList.filter(dept =>
                                                dept.name.toLowerCase().includes(searchTerm)
                                            );
                                            setFilteredDepartmentList(filtered);
                                        }
                                    }}
                                    sx={{
                                        backgroundColor: 'white',
                                        '& .MuiOutlinedInput-root': {
                                            borderRadius: '8px'
                                        }
                                    }}
                                />
                            </Box>

                            <Box sx={{ flexGrow: 1, overflowY: 'auto', p: 1, pt: 0 }}>
                                <List component="nav" dense>
                                    {filteredDepartmentList.length > 0 ? (
                                        filteredDepartmentList.map((department) => (
                                            <ListItemButton
                                                key={department.id}
                                                selected={selectedDepartmentId === department.id}
                                                onClick={() => handleDepartmentClick(department)}
                                                sx={{
                                                    borderRadius: '8px',
                                                    my: 0.5,
                                                    '&.Mui-selected': {
                                                        backgroundColor: theme.palette.primary.main,
                                                        color: theme.palette.primary.contrastText,
                                                        '&:hover': { backgroundColor: theme.palette.primary.dark }
                                                    },
                                                    '&:hover': { backgroundColor: theme.palette.action.hover },
                                                    justifyContent: "center",
                                                }}
                                            >
                                                <ListItemText
                                                    primary={department.name}
                                                    primaryTypographyProps={{
                                                        fontWeight: 500,
                                                        textAlign: 'center',
                                                        sx: {
                                                            overflow: 'hidden',
                                                            textOverflow: 'ellipsis',
                                                            whiteSpace: 'nowrap'
                                                        }
                                                    }}
                                                />
                                            </ListItemButton>
                                        ))
                                    ) : (
                                        <ListItem>
                                            <ListItemText
                                                primary="No departments found"
                                                sx={{ textAlign: 'center', mt: 2, color: 'text.secondary' }}
                                            />
                                        </ListItem>
                                    )}
                                </List>
                            </Box>
                        </Card>
                    </Grid>

                    {/* Department Wise Count Chart */}
                    <Grid item xs={12} md={8}>
                        <Card
                            elevation={3}
                            sx={{
                                borderRadius: '16px',
                                height: '400px',
                                display: 'flex',
                                flexDirection: 'column',
                                width: '100%'
                            }}
                        >
                            <CardHeader
                                title="Department Wise Document Counts"
                                titleTypographyProps={{
                                    variant: 'h6',
                                    fontWeight: 'bold'
                                }}
                                sx={{
                                    background: `linear-gradient(135deg, ${theme.palette.secondary.light} 0%, ${theme.palette.secondary.main} 100%)`,
                                    color: theme.palette.secondary.contrastText,
                                    py: 1.5,
                                    flexShrink: 0
                                }}
                            />
                            <CardContent
                                sx={{
                                    flexGrow: 1,
                                    p: 1.5,
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    overflow: 'hidden',
                                    width: '100%',
                                    height: '100%'
                                }}
                            >
                                {isDeptChartLoading ? (
                                    <Box sx={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        alignItems: 'center',
                                        gap: 2,
                                        width: '100%',
                                        height: '100%',
                                        justifyContent: 'center'
                                    }}>
                                        <CircularProgress color="secondary" size={40} />
                                        <Typography variant="body2" color="text.secondary">
                                            Loading chart data...
                                        </Typography>
                                    </Box>
                                ) : deptChartError ? (
                                    <Alert severity="error" sx={{ width: '90%', m: 1 }}>
                                        {deptChartError}
                                    </Alert>
                                ) : chartOptions && chartSeries.length > 0 ? (
                                    <Box
                                        sx={{
                                            width: '100%',
                                            height: '100%',
                                            position: 'relative',
                                            minHeight: '300px'
                                        }}
                                    >
                                        <ReactApexChart
                                            options={chartOptions}
                                            series={chartSeries}
                                            type="bar"
                                            height="100%"
                                            width="100%"
                                        />
                                    </Box>
                                ) : (
                                    <Box
                                        sx={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            width: '100%',
                                            height: '100%'
                                        }}
                                    >
                                        <Typography
                                            variant="body1"
                                            sx={{ textAlign: 'center', color: 'text.secondary', p: 2 }}
                                        >
                                            No department count data available.
                                        </Typography>
                                    </Box>
                                )}
                            </CardContent>
                        </Card>
                    </Grid>

                </Grid>
            </Box>

            {/* --- Document Details Modal --- */}
            <Dialog
                open={isModalOpen}
                onClose={handleCloseModal}
                maxWidth="xl"
                fullWidth
                scroll="paper"
                PaperProps={{
                    sx: {
                        maxHeight: "80vh",        // smaller height
                        height: "auto"            // auto adjust
                    }
                }}
            >

                <DialogTitle sx={{ bgcolor: theme.palette.primary.main, color: theme.palette.primary.contrastText, py: 1.5, fontSize: '1.1rem', m: 0, borderBottom: `1px solid ${theme.palette.divider}` }}>
                    Document Details
                </DialogTitle>
                <Box sx={{ p: 1.5, borderBottom: `1px solid ${theme.palette.divider}`, backgroundColor: theme.palette.grey[50], position: 'sticky', top: 0, zIndex: 1101 }}>
                    <TextField fullWidth size="small" variant="outlined" label="Search Documents (ID, File No, Definition, Dept, Subject...)" value={searchQuery} onChange={(e) => setSearchQuery(e.target.value)} sx={{ backgroundColor: 'white' }} />
                </Box>
                {isLoadingModal && <LinearProgress color="primary" sx={{ position: 'sticky', top: 57, zIndex: 1101 }} />}
                <DialogContent dividers sx={{ p: 0, '&.MuiDialogContent-root': { padding: 0 } }}>
                    {modalError ? (
                        <Box sx={{ p: 3 }}><Alert severity="error">{modalError}</Alert></Box>
                    ) : (
                        <>
                            <TableContainer component={Paper} elevation={0} square sx={{ maxHeight: 'calc(100vh - 64px - 58px - 53px)' }}>
                                <Table stickyHeader aria-label="collapsible document table" size="small">
                                    <TableHead>
                                        <TableRow sx={{ '& th': { backgroundColor: theme.palette.grey[200], fontWeight: 'bold', color: theme.palette.text.primary, padding: '6px 10px', position: 'sticky', top: 0, zIndex: 1 } }}>
                                            <TableCell sx={{ width: '50px' }} />
                                            <TableCell>File No</TableCell>
                                            <TableCell>Definition</TableCell>
                                            <TableCell>Department</TableCell>
                                            <TableCell>Date</TableCell>
                                            <TableCell>Files</TableCell>
                                            <TableCell align="center">Preview</TableCell> {/* Yahan align="center" add karo */}
                                        </TableRow>
                                    </TableHead>

                                    <TableBody>
                                        {isLoadingModal && !modalData.length ? (
                                            <TableRow><TableCell colSpan={7} align="center" sx={{ p: 5 }}><CircularProgress /></TableCell></TableRow>
                                        ) : filteredModalData.length > 0 ? (

                                            filteredModalData
                                                .slice((modalPage - 1) * modalRowsPerPage, modalPage * modalRowsPerPage)
                                                .map((doc, index) => (
                                                    <DocRow
                                                        key={doc.docMid}
                                                        doc={doc}
                                                        isOpen={openRowId === doc.docMid}
                                                        onToggle={() => setOpenRowId(openRowId === doc.docMid ? null : doc.docMid)}
                                                        formatDate={formatDate}
                                                        theme={theme}
                                                        isEvenRow={index % 2 === 0}
                                                    />
                                                ))

                                        ) : (
                                            <TableRow>
                                                <TableCell colSpan={7} align="center">
                                                    <Typography color="textSecondary" sx={{ p: 3, fontStyle: 'italic' }}>
                                                        {searchQuery ? "No documents match your search criteria." : "No document details found."}
                                                    </Typography>
                                                </TableCell>
                                            </TableRow>
                                        )}
                                    </TableBody>
                                </Table>
                            </TableContainer>

                            {/* Pagination */}
                            <Box
                                sx={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    py: 2,
                                    px: 2
                                }}
                            >
                                <Typography variant="body2" fontWeight="bold">
                                    Total Records: {filteredModalData.length}
                                </Typography>

                                <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                                    <IconButton
                                        color="primary"
                                        disabled={modalPage === 1}
                                        onClick={() => setModalPage(prev => prev - 1)}
                                    >
                                        <ChevronLeftIcon />
                                    </IconButton>

                                    <Typography variant="body2" sx={{ fontWeight: 600 }}>
                                        {modalPage} / {Math.ceil(filteredModalData.length / modalRowsPerPage)}
                                    </Typography>

                                    <IconButton
                                        color="primary"
                                        disabled={modalPage >= Math.ceil(filteredModalData.length / modalRowsPerPage)}
                                        onClick={() => setModalPage(prev => prev + 1)}
                                    >
                                        <ChevronRightIcon />
                                    </IconButton>
                                </Box>
                            </Box>

                        </>


                    )}
                </DialogContent>
                <DialogActions sx={{ p: 1.5, borderTop: `1px solid ${theme.palette.divider}`, backgroundColor: theme.palette.grey[50] }}>
                    <Button onClick={handleCloseModal} variant="contained" color="primary" size="medium">Close</Button>
                </DialogActions>
            </Dialog>

            {/* --- Document Type Modal --- */}
            <Dialog open={isDocTypeModalOpen} onClose={handleCloseDocTypeModal} maxWidth="lg" fullWidth scroll="paper" PaperProps={{ sx: { maxHeight: '85vh', height: 'calc(100% - 64px)' } }}>
                <DialogTitle sx={{ bgcolor: theme.palette.primary.main, color: theme.palette.primary.contrastText, py: 1.5, fontSize: '1.1rem', m: 0, borderBottom: `1px solid ${theme.palette.divider}` }}>
                    Document Types
                </DialogTitle>
                <Box sx={{ p: 1.5, borderBottom: `1px solid ${theme.palette.divider}`, backgroundColor: theme.palette.grey[50], position: 'sticky', top: 0, zIndex: 1101 }}>
                    <TextField fullWidth size="small" variant="outlined" label="Search Document Types (Name, Short Name, Parent, Year...)" value={docTypeSearchQuery} onChange={(e) => setDocTypeSearchQuery(e.target.value)} sx={{ backgroundColor: 'white' }} />
                </Box>
                {isLoadingDocTypeModal && <LinearProgress color="secondary" sx={{ position: 'sticky', top: 57, zIndex: 1101 }} />}
                <DialogContent dividers sx={{ p: 0, '&.MuiDialogContent-root': { padding: 0 } }}>
                    {docTypeModalError ? (
                        <Box sx={{ p: 3 }}><Alert severity="error">{docTypeModalError}</Alert></Box>
                    ) : (
                        <TableContainer component={Paper} elevation={0} square sx={{ maxHeight: 'calc(100vh - 64px - 58px - 53px)' }}>
                            <Table stickyHeader aria-label="document type table" size="small">
                                <TableHead>
                                    <TableRow sx={{ '& th': { backgroundColor: theme.palette.grey[200], fontWeight: 'bold', color: theme.palette.text.primary, padding: '6px 10px', position: 'sticky', top: 0, zIndex: 1 } }}>
                                        <TableCell>Name</TableCell>
                                        <TableCell>Short Name</TableCell>
                                        <TableCell>Parent Name</TableCell>
                                        <TableCell align="right">Entry Date</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {isLoadingDocTypeModal && !docTypeData.length ? (
                                        <TableRow><TableCell colSpan={5} align="center" sx={{ p: 5 }}><CircularProgress color="secondary" /></TableCell></TableRow>
                                    ) : filteredDocTypeData.length > 0 ? (
                                        filteredDocTypeData.map((docType, index) => (
                                            <TableRow key={docType.docID || `doctype-${index}`} sx={{ '&:nth-of-type(odd)': { backgroundColor: theme.palette.action.hover }, '&:last-child td, &:last-child th': { border: 0 }, }}>
                                                <TableCell sx={{ padding: '6px 10px' }}>{docType.doc_Name || '-'}</TableCell>
                                                <TableCell sx={{ padding: '6px 10px' }}>{docType.doc_shortname || '-'}</TableCell>
                                                <TableCell sx={{ padding: '6px 10px' }}>{docType.parentDoc_Name || '-'}</TableCell>
                                                <TableCell align="right" sx={{ padding: '6px 10px' }}>{formatDate(docType.entry_Date)}</TableCell>
                                            </TableRow>
                                        ))
                                    ) : (
                                        <TableRow><TableCell colSpan={5} align="center"><Typography color="textSecondary" sx={{ p: 3, fontStyle: 'italic' }}>{docTypeSearchQuery ? "No document types match your search criteria." : "No document types found."}</Typography></TableCell></TableRow>
                                    )}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    )}
                </DialogContent>
                <DialogActions sx={{ p: 1.5, borderTop: `1px solid ${theme.palette.divider}`, backgroundColor: theme.palette.grey[50] }}>
                    <Button onClick={handleCloseDocTypeModal} variant="contained" color="primary" size="medium">Close</Button>
                </DialogActions>
            </Dialog>

            {/* --- Total Index/Split Files Modal --- */}
            <Dialog open={isTotalFilesModalOpen} onClose={handleCloseTotalFilesModal} maxWidth="lg" fullWidth scroll="paper" PaperProps={{ sx: { maxHeight: '85vh', height: 'calc(100% - 64px)' } }}>
                <DialogTitle sx={{ bgcolor: theme.palette.primary.main, color: theme.palette.primary.contrastText, py: 1.5, fontSize: '1.1rem', m: 0, borderBottom: `1px solid ${theme.palette.divider}` }}>
                    Total Index/Split Files
                </DialogTitle>
                <Box sx={{ p: 1.5, borderBottom: `1px solid ${theme.palette.divider}`, backgroundColor: theme.palette.grey[50], position: 'sticky', top: 0, zIndex: 1101 }}>
                    <TextField fullWidth size="small" variant="outlined" label="Search by File Name" value={totalFilesSearchQuery} onChange={(e) => setTotalFilesSearchQuery(e.target.value)} sx={{ backgroundColor: 'white' }} />
                </Box>
                {isLoadingTotalFiles && <LinearProgress color="secondary" sx={{ position: 'sticky', top: 57, zIndex: 1101 }} />}
                <DialogContent dividers sx={{ p: 0, '&.MuiDialogContent-root': { padding: 0 } }}>
                    <TableContainer component={Paper} elevation={0} square sx={{ maxHeight: 'calc(100vh - 64px - 58px - 53px)' }}>
                        <Table stickyHeader aria-label="total files table" size="small">
                            <TableHead>
                                <TableRow sx={{ '& th': { backgroundColor: theme.palette.grey[200], fontWeight: 'bold', color: theme.palette.text.primary, padding: '6px 10px', position: 'sticky', top: 0, zIndex: 1 } }}>
                                    <TableCell>File Name</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {isLoadingTotalFiles && !(isIndex?.length > 0) ? (
                                    <TableRow><TableCell colSpan={1} align="center" sx={{ p: 5 }}><CircularProgress color="secondary" /></TableCell></TableRow>
                                ) : filteredTotalFilesData.length > 0 ? (
                                    filteredTotalFilesData.map((item: any, index: any) => (
                                        <TableRow key={item?.pdfid || `file-${index}`} sx={{ '&:nth-of-type(odd)': { backgroundColor: theme.palette.action.hover }, '&:last-child td, &:last-child th': { border: 0 } }}>
                                            <TableCell sx={{ padding: '6px 10px', wordBreak: 'break-all' }}>{item?.fileName || '-'}</TableCell>
                                        </TableRow>
                                    ))
                                ) : (
                                    <TableRow><TableCell colSpan={1} align="center"><Typography color="textSecondary" sx={{ p: 3, fontStyle: 'italic' }}>{totalFilesSearchQuery ? "No files match your search criteria." : "No files found."}</Typography></TableCell></TableRow>
                                )}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </DialogContent>
                <DialogActions sx={{ p: 1.5, borderTop: `1px solid ${theme.palette.divider}`, backgroundColor: theme.palette.grey[50] }}>
                    <Button onClick={handleCloseTotalFilesModal} variant="contained" color="primary" size="medium">Close</Button>
                </DialogActions>
            </Dialog>

            {/* --- Department Documents Swipeable Drawer --- */}
            <SwipeableDrawer
                anchor="right"
                open={isDeptDrawerOpen}
                onClose={toggleDrawer(false)}
                onOpen={toggleDrawer(true)}
                disableBackdropTransition={!iOS}
                disableDiscovery={iOS}
                PaperProps={{
                    sx: {
                        width: { xs: '95%', sm: '85%', md: '75%', lg: '65%' },
                        maxWidth: '1100px',
                        height: '100vh',
                        borderTopLeftRadius: 16,
                        borderBottomLeftRadius: 16,
                        borderTopRightRadius: 0,
                        display: 'flex',
                        flexDirection: 'column',
                        boxShadow: theme.shadows[8],
                        backgroundColor: theme.palette.background.default,
                    }
                }}
                sx={{
                    zIndex: theme.zIndex.drawer + 1
                }}
            >
                {/* Drawer Header */}
                <Box sx={{
                    p: 2,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    borderBottom: `1px solid ${theme.palette.divider}`,
                    backgroundColor: theme.palette.primary.main,
                    color: theme.palette.primary.contrastText,
                    flexShrink: 0,
                }}>
                    <Typography variant="h6" component="div" sx={{ fontWeight: 'bold' }}>
                        {selectedDepartment ? `${selectedDepartment}` : 'Department'} Documents
                    </Typography>
                    <IconButton
                        aria-label="close"
                        onClick={toggleDrawer(false)}
                        sx={{ color: theme.palette.primary.contrastText }}
                    >
                        <CloseIcon />
                    </IconButton>
                </Box>

                {/* Drawer Search Bar */}
                <Box sx={{ p: 1.5, borderBottom: `1px solid ${theme.palette.divider}`, backgroundColor: theme.palette.background.paper, flexShrink: 0 }}>
                    <TextField
                        fullWidth size="small" variant="outlined"
                        placeholder="Search by File No, Definition, Subject..."
                        value={deptDataSearchQuery}
                        onChange={(e) => setDeptDataSearchQuery(e.target.value)}
                        sx={{
                            '& .MuiOutlinedInput-root': { borderRadius: '8px' },
                            backgroundColor: 'white'
                        }}
                    />
                </Box>

                {/* Loading Bar */}
                {isLoadingDeptData && <LinearProgress color="primary" sx={{ width: '100%', flexShrink: 0 }} />}

                {/* Drawer Content - Scrollable Table */}
                <Box sx={{ flexGrow: 1, overflow: 'hidden', p: 0, backgroundColor: theme.palette.background.paper, display: 'flex', flexDirection: 'column' }}>
                    {deptDataError ? (
                        <Box sx={{ p: 3, display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                            <Alert severity="warning" sx={{ width: '90%' }}>{deptDataError}</Alert>
                        </Box>
                    ) : (
                        <>
                            <TableContainer component={Paper} elevation={0} square sx={{ flexGrow: 1, overflowY: 'auto' }}>
                                <Table stickyHeader aria-label="collapsible department document table" size="small">
                                    <TableHead>
                                        <TableRow sx={{ '& th': { backgroundColor: theme.palette.grey[200], fontWeight: 'bold', color: theme.palette.text.primary, padding: '6px 10px', position: 'sticky', top: 0, zIndex: 1 } }}>
                                            <TableCell sx={{ width: '50px' }} />
                                            <TableCell>File No</TableCell>
                                            <TableCell>Definition</TableCell>
                                            <TableCell>Department</TableCell>
                                            <TableCell>Date</TableCell>
                                            <TableCell>Files</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {isLoadingDeptData && !selectedDeptData.length ? (

                                            <TableRow>
                                                <TableCell colSpan={7} align="center" sx={{ p: 5, border: 0 }}>
                                                    <CircularProgress />
                                                    <Typography variant="body2" color="textSecondary" sx={{ mt: 1 }}>
                                                        Loading documents...
                                                    </Typography>
                                                </TableCell>
                                            </TableRow>

                                        ) : filteredSelectedDeptData.length > 0 ? (

                                            filteredSelectedDeptData
                                                .slice((drawerPage - 1) * drawerRowsPerPage, drawerPage * drawerRowsPerPage)
                                                .map((doc, index) => (
                                                    <DocRow
                                                        key={doc.docMid}
                                                        doc={doc}
                                                        isOpen={openDrawerRowId === doc.docMid}
                                                        onToggle={() =>
                                                            setOpenDrawerRowId(
                                                                openDrawerRowId === doc.docMid ? null : doc.docMid
                                                            )
                                                        }
                                                        formatDate={formatDate}
                                                        theme={theme}
                                                        isEvenRow={index % 2 === 0}
                                                    />
                                                ))

                                        ) : (
                                            <TableRow>
                                                <TableCell colSpan={7} align="center" sx={{ p: 4, border: 0 }}>
                                                    <Typography color="textSecondary" sx={{ fontStyle: "italic" }}>
                                                        {deptDataSearchQuery
                                                            ? "No documents match your search criteria."
                                                            : `No documents found for ${selectedDepartment}.`}
                                                    </Typography>
                                                </TableCell>
                                            </TableRow>
                                        )}
                                    </TableBody>

                                </Table>
                            </TableContainer>

                            <Box
                                sx={{
                                    position: "sticky",
                                    bottom: 0,
                                    background: theme.palette.background.paper,
                                    borderTop: `1px solid ${theme.palette.divider}`,
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    py: 1.5,
                                    px: 2,
                                    zIndex: 1000
                                }}
                            >
                                <Typography variant="body2" fontWeight="bold">
                                    Total Records: {filteredSelectedDeptData.length}
                                </Typography>

                                <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                                    <IconButton
                                        color="primary"
                                        disabled={drawerPage === 1}
                                        onClick={() => setDrawerPage(prev => prev - 1)}
                                    >
                                        <ChevronLeftIcon />
                                    </IconButton>

                                    <Typography variant="body2" sx={{ fontWeight: 600 }}>
                                        {drawerPage} / {Math.ceil(filteredSelectedDeptData.length / drawerRowsPerPage)}
                                    </Typography>

                                    <IconButton
                                        color="primary"
                                        disabled={drawerPage >= Math.ceil(filteredSelectedDeptData.length / drawerRowsPerPage)}
                                        onClick={() => setDrawerPage(prev => prev + 1)}
                                    >
                                        <ChevronRightIcon />
                                    </IconButton>
                                </Box>
                            </Box>


                        </>

                    )}
                </Box>
            </SwipeableDrawer>

        </Box>
    );
}